import PatientAppointment from 'Screens/Home/SystemPatient/components/PatientAppointment/index';
import DeletePatient from 'Screens/Home/SystemPatient/components/Delete/delete';
import EditPatient from 'Screens/Home/SystemPatient/components/Edit/edit';
import DeleteUser from 'Screens/Home/SystemUser/components/Delete/delete';
import EditUser from 'Screens/Home/SystemUser/components/Edit/edit';
import UserAccess from 'Screens/Home/SystemUser/components/AccessLevel/access';
import EditUserPass from 'Screens/Home/SystemUser/components/UserPass/editAuth';
import PatientSelect from 'Screens/Home/Dashboard/components/NewAppointment/PatientSelect';
import DeletePayment from 'Screens/Home/Appointments/gridMode/components/manager/DeletePayment';
import PatientShow from 'Screens/Home/SystemPatient/components/PatientShow';
import GetAppointmentTime from './AppointmentTime';
import GetAppointmentStatus from './AppointmentStatus';
import GetAppointmentType from './AppointmentType';
import AppointmentStatusEdit from 'Screens/Home/Appointments/gridMode/components/manager/StatusEdit';
import AppointmentNewPayment from 'Screens/Home/Appointments/gridMode/components/manager/NewPayment';
import AppointmentHistory from 'Screens/Home/Appointments/gridMode/components/history';
import AppointmentTypeEdit from 'Screens/Home/Appointments/gridMode/components/manager/EditAppointmentType';
import AppointmentDelete from 'Screens/Home/Appointments/gridMode/components/manager/DeleteAppointment';
import PayTypeShow from 'Screens/Home/Appointments/gridMode/components/history/PayTypeShow';

export const patientList = [
  {
    field: 'bypass_group_id',
    headerName: ' ',
    width: 40,
    renderCell: (row) => {
      return <PatientSelect row={row} />
    }
  },
  { 
    field: 'name', 
    headerName: "نام بیمار",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  { 
    field: 'uniCode', 
    headerName: "شماره پرونده",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
];

export const patientListMain = [
  { 
      field: 'name', 
      headerName: "نام بیمار",
      align: 'center',
      headerAlign: 'center',
      editable: false,
      sortable: false,
      flex: 1,
  },
  { 
    field: 'uniCode', 
    headerName: "شماره پرونده",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  { 
    field: 'nCode', 
    headerName: "کد ملی",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  { 
    field: 'mobile', 
    headerName: "شماره موبایل",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: 'عملیات',
    type: 'actions',
    headerName: '',
    width: 120,
    cellClassName: 'actions',
    getActions: ({ cell, row }) => {
      return [
        <PatientAppointment cell={cell} row={row} />,
        <EditPatient cell={cell} row={row} />,
        <DeletePatient cell={cell} row={row} />,
      ]
    }
  },
];

export const userList = [
  { 
      field: 'name', 
      headerName: "نام بیمار",
      align: 'center',
      headerAlign: 'center',
      editable: false,
      sortable: false,
      flex: 1,
  },
  { 
    field: 'mobile', 
    headerName: "شماره موبایل",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: 'عملیات',
    type: 'actions',
    headerName: '',
    align: 'left',
    headerAlign: 'center',
    width: 160,
    cellClassName: 'actions',
    getActions: ({ cell, row }) => {
      return [
        <UserAccess cell={cell} row={row} />,
        <EditUserPass cell={cell} row={row} />,
        <EditUser cell={cell} row={row} />,
        <DeleteUser cell={cell} row={row} />,
      ]
    }
  },
];


export const paymentList = [
  { 
      field: 'date', 
      headerName: "تاریخ",
      align: 'center',
      headerAlign: 'center',
      editable: false,
      sortable: false,
      flex: 1,
  },
  { 
    field: 'price', 
    headerName: "مبلغ",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  { 
    field: 'type', 
    headerName: "نوع",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
    renderCell: (row) => {
      return <PayTypeShow id={row.value}/>
    }
  },
  { 
    field: 'creatingUser', 
    headerName: "کاربر",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  { 
    field: 'description', 
    headerName: "توضیحات",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: 'عملیات',
    type: 'actions',
    headerName: '',
    width: 40,
    cellClassName: 'actions',
    getActions: ({ cell, row }) => {
      return [
        <DeletePayment cell={cell} row={row} />,
      ]
    }
  },
];

export const appointmentsList = [
  {
    field: 'patient_data',
    headerName: "نام بیمار",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
    renderCell: (row) => {
      return <PatientShow name={row.row.name} nCode={row.row.nCode} mobile={row.row.mobile} uniCode={row.row.uniCode} />
    }
  },
  {
    field: 'appointment_date',
    headerName: "تاریخ نوبت",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
    renderCell: (row) => {
      return <GetAppointmentTime id={row.row.time} date={row.row.date} status={row.row.lastStatus} AppointmentPage inDate/>
    }
  },
  {
    field: 'appointment_status',
    headerName: "آخرین وضعیت",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
    renderCell: (row) => {
      return <GetAppointmentStatus id={row.row.lastStatus}/>
    }
  },
  {
    field: 'appointment_type',
    headerName: "نوع نوبت",
    align: 'center',
    headerAlign: 'center',
    editable: false,
    sortable: false,
    flex: 1,
    renderCell: (row) => {
      return <GetAppointmentType id={row.row.type} />
    }
  },
  {
    field: 'عملیات',
    type: 'actions',
    headerName: '',
    editable: false,
    sortable: false,
    flex: 1,
    cellClassName: 'actions',
    getActions: ({ cell, row }) => {
      return [
        <>
          {
            row.lastStatus !== 5 ? 
            <>
              <>
                {
                  row.lastStatus !== 4
                  ? <AppointmentStatusEdit key={`app_sted_${row.id}`} id={row.id} />
                  : <AppointmentNewPayment key={`app_pay_${row.id}`} id={row.id} />
                }
              </>
              <AppointmentHistory key={`app_his_${row.id}`} data={row} patient={false}/>
              <AppointmentTypeEdit key={`app_typ_${row.id}`} data={row} patient={false}/>
              <AppointmentDelete key={`app_del_${row.id}`} data={row} patient={false}/>
            </> : <AppointmentHistory key={`app_his_alt_${row.id}`} data={row} patient={false}/>
          }
        </>
      ]
    }
  },
];